module.exports = __webpack_public_path__ + "static/bg02-869af6d522ce9f72d82622850316ccec.jpg";